<script setup>
</script>
<template>
    <div class="loader">
        <img class="loader__img" width="36" height="36" src="@/assets/img/loader_pepsi.webp" alt="изображение лодера" />
    </div>
</template>
<style lang='scss' scoped>
.loader {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    z-index: 1;

    background-image: url('@/assets/img/other/main_bg.webp');
	background-repeat: no-repeat;
	background-position: center 70%;
    background-size: 84.8rem;
    background-color: var(--fill-default-1);
}
.loader__img {
    width: 129px;
    height: 129px;
    // animation: loader 1.5s linear infinite;
    animation: pepsiAnim 1.7s ease-in-out infinite;

    transform-origin: center;
}
@keyframes loader {
    0% {transform: rotate(0);}
    100% {transform: rotate(360deg);}
}
@keyframes pepsiAnim {
    0% {
        transform: scale(1) rotate(0deg);
    }
    35% {
        transform: scale(1.15) rotate(360deg);
    }
    50% {
        transform: scale(1) rotate(360deg);
    }
    100% {
        transform: scale(1) rotate(360deg);
    }

}
</style>